// extracted by mini-css-extract-plugin
module.exports = {"DocumentCard":"DocumentDetailsView_DocumentCard__b6exh"};